import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Check } from "lucide-react";

export default function Portfolio() {
  return (
    <div data-testid="page-portfolio">
      <section className="px-6 md:px-12 lg:px-24 pt-32 md:pt-40 pb-16">
        <div className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-primary mb-6">
          <span className="inline-block w-2 h-2 bg-accent" />
          Unser Suchprofil
        </div>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-light tracking-tighter leading-[1.05] max-w-4xl">
          Welche <em className="italic">Objekte</em> wir suchen.
        </h1>
        <p className="mt-8 max-w-2xl text-base sm:text-lg text-muted-foreground leading-relaxed">
          Unser Fokus liegt klar definiert. Was wir hier beschreiben, ist nicht
          Wunschdenken, sondern unser tatsächliches Suchprofil. Bietet Ihr Haus
          eine Überschneidung, freuen wir uns sehr über ein Gespräch.
        </p>
      </section>

      <section className="px-6 md:px-12 lg:px-24 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8">
          {[
            { t: "Größe", v: "Mehrfamilienhäuser mit 3 bis 6 Wohneinheiten." },
            { t: "Stil & Baujahr", v: "Gründerzeit, Jugendstil, klassische Bürgerhäuser – Häuser mit erkennbarem Charakter." },
            { t: "Lage", v: "Oberfranken und nördliches Bayern, besonders Hochfranken: Münchberg, Selb, Rehau, Hof, Naila, Schwarzenbach a. d. Saale, Marktredwitz und Umgebung." },
            { t: "Zustand", v: "Leichter bis vollständiger Sanierungsbedarf. Wir bringen das Wissen, die Geduld und das Kapital mit." },
            { t: "Auch interessant", v: "Vermietete Objekte, Erbengemeinschaften, Denkmalschutz, leerstehende Häuser." },
          ].map((row) => (
            <div key={row.t} className="border-t border-border pt-5">
              <div className="text-xs uppercase tracking-[0.25em] text-primary mb-2">{row.t}</div>
              <p className="text-base text-foreground/90 leading-relaxed">{row.v}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-muted/40 border-y border-border px-6 md:px-12 lg:px-24 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-5xl">
          <div>
            <h2 className="font-serif text-3xl sm:text-4xl mb-4">Was Sie von uns erwarten können</h2>
            <ul className="space-y-3">
              {[
                "Diskrete, persönliche Erstprüfung",
                "Faires Angebot innerhalb weniger Wochen",
                "Abwicklung über erfahrenen Notar",
                "Langfristige Verwaltung in Eigenregie",
              ].map((i) => (
                <li key={i} className="flex items-start gap-3 text-sm">
                  <Check className="h-4 w-4 text-primary mt-0.5 shrink-0" strokeWidth={2} />
                  {i}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h2 className="font-serif text-3xl sm:text-4xl mb-4">Was wir nicht tun</h2>
            <ul className="space-y-3 text-muted-foreground">
              {[
                "Großwohnanlagen oder Neubauprojekte",
                "Reine Spekulation oder schneller Weiterverkauf",
                "Standorte außerhalb Nordbayerns",
                "Unsaubere Eigentumsverhältnisse",
              ].map((i) => (
                <li key={i} className="text-sm">— {i}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-24 py-24 text-center">
        <h2 className="font-serif text-4xl sm:text-5xl font-light tracking-tight max-w-3xl mx-auto">
          Passt Ihr Haus zu unserem Profil?
        </h2>
        <Link to="/verkaufen">
          <Button className="mt-10 rounded-none bg-primary hover:bg-primary/90 text-primary-foreground h-12 px-10 text-sm tracking-wide">
            Objekt anbieten <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </Link>
      </section>
    </div>
  );
}
